import { QueryClientConfig } from '@tanstack/react-query';
import { NotLoggedInError } from '../domain/errors/NotLoggedInError';
import { getLogger } from './logger/logger';
import { APP_CONFIG } from '../config';
import { shouldForwardErrorToErrorBoundary } from './shouldForwardErrorToErrorBoundry.util';

export const getQueryClientConfig = (): QueryClientConfig => ({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      retry: 2,
      refetchOnWindowFocus: false,
      retryOnMount: false,
      useErrorBoundary: shouldForwardErrorToErrorBoundary,
      onError: (error) => {
        if (error instanceof NotLoggedInError) {
          getLogger('benefits-page').info('User is not logged in.');
          location.replace(`${APP_CONFIG.ssoUrl}?appName=membership&sso_return=${encodeURIComponent(location.href)}`);
        }
      },
    },
  },
});
